/**********************************************************************************************************************/
/* FILE: hafas_webapp_printview.js                                                                                          */
/**********************************************************************************************************************/
// contstructor for webapp printview, declare global Hafas-Variables
var HafasWebappPrintview = function (params) {
  // Set Bool Flag that print view is active
  Hafas.Config.isPrintView = true;

  var headerName = Hafas.Modules.i18n.get('common.print.t_N_Printview');
  document.title = headerName + ' - ' + Hafas.Config.client.name;
  if(Hafas.Modules.a11y) Hafas.Modules.a11y.Announce.polite(headerName);

  // Atom-Modul anmelden
  Hafas.Core.newType("hafasAtoms", {
    Controller: this.Controller
  });

  // Registriere das resize Event
  Hafas.Core.listenToEvent(window, 'resize', function (e) {
    Hafas.ps.pub('/app/events/resize', [{windowResize: true, print: true}]);
    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
  });

  // welche art der druckansicht?
  var printviewConfiguration = 'tp';
  var printviewId = '';

  if (Hafas.Core.getParameterByName('mode') !== null) {
    printviewConfiguration = Hafas.Core.getParameterByName('mode');
  }

  if (Hafas.Core.getParameterByName('id') !== null) {
    printviewId = Hafas.Core.getParameterByName('id');
  }

  Hafas('html').addClassName('lyr_PRINT_' + printviewConfiguration);

  //merged templates (HDSWAPP-2216), configuration accordingly to the printviewConfiguration
  if (printviewConfiguration === 'tp' || printviewConfiguration === 'tpConfigurator') {
    var prtCfg = Hafas.Config.Print;
    var dataObject;

    if (printviewConfiguration === 'tp') {
      dataObject = JSON.parse(window.opener.globalPrintObj['print_tp_' + printviewId]);
      //necessary to center the view
      dataObject.useToolbox = true;
      dataObject.useConnections = true;
      dataObject.useSummary = false;
      dataObject.useOverviewSummary = false;
      dataObject.showMaps = false;
    } else {
      dataObject = JSON.parse(window.opener.globalPrintObj['print_tpConfigurator_' + printviewId]);
      dataObject.useToolbox = prtCfg.useToolbox;
      dataObject.useConnections = prtCfg.useConnections;
      dataObject.useSummary = prtCfg.useSummary;
      dataObject.useOverviewSummary = prtCfg.useOverviewSummary;
      dataObject.showMaps = prtCfg.showMaps;
      //dataObject.useOverviewTable = false;

      var headerTextBlock = 'Overview_1';
      if (dataObject.printMode === 'overview') {
        dataObject.useToolbox = false;
        dataObject.useConnections = false;
        dataObject.useOverviewTable = true;
      }
    }

    prepareConnections(dataObject);
    //since the datamodel in both tp and tpConfigurator is different and the value dur is necessary for
    //the template-generation process, we have to add this value manually if the configuration is "tp" (old printview HDSWAPP-2216)
    if (dataObject.connections[0].dur && !dataObject.connections[0].secL[0].dur && printviewConfiguration === 'tp') {
      dataObject.connections[0].secL[0].dur = dataObject.connections[0].dur;
    }

    dataObject.webappWrap = "HFS_PRINT";
    dataObject.contentTemplate = 'TP_TplPrintConfigurator_Content';

    Hafas.Modules.Loader.loadTemplateFiles(['common.html', 'common.map.html', 'common.input.html','common.messages.html','tp.print.html','tp.print_configurator.html','common.new.html', 'common.content.html', 'common.buttons.html', 'common.print.html','common.icons.html', 'common.product.html'], function () {
      Hafas.Modules.Render.render({
        file: 'tp.print_configurator.html',
        target: 'HFS_PRINT',
        template: 'Print_TplPrintBase',
        model: dataObject
      }, function () {
        if (printviewConfiguration === 'tp') {
          Hafas('#HFS_printContentWrapper').addClassName('lyr_compactPrintView');
          Hafas('#HFS_multiPrintConnectionWrapper_0', false).removeAttribute("hidden");
        } else {
          // Resize first to set the initial view of print configurator -> small view > compact mode only
          Hafas.ps.pub('/app/events/resize', [{windowResize: true, print: true}]);

          // Show QR code if feature is enabled
          if (Hafas.Config.Print.useQrCode) {
            Hafas.ps.pub('/printConfigurator/toggleQrCode', [true]);
          }

          // Toolbox activated?
          if (Hafas.Config.Print.useToolbox) {

            Hafas.Modules.Render.render({
              file: 'tp.print_configurator.html',
              target: 'HFS_printConfigurator',
              template: 'TP_TplPrintConfigurator_Toolbox',
              model: dataObject
            }, function () {

              // die abschnitte durchgehen und ggf. leere divs fuer zusatzinfos ausblenden
              Hafas('.lyr_productDetails.lyr_moreDetailsContent', true).forEach(function (elem) {
                var connIdx = elem.getAttribute('data-connidx');
                var sectionIdx = elem.getAttribute('data-sectionidx');

                if (Hafas('*', true, elem).length === 0) {
                  Hafas.Util.gui.setVisibility(Hafas('#productDetailsWrapper_' + connIdx + '_' + sectionIdx),false);
                  Hafas.Util.gui.setVisibility(Hafas('#tb_productDetails_' + connIdx + '_' + sectionIdx),false);
                }
              });

              // first of all the overview maps
              if(Hafas.Config.Print.useMaps) {
                Hafas('[data-map="overview"]',true).forEach(function(map,index){
                  window.setTimeout(function(){
                    Hafas.ps.pub('/printConfigurator/addMap',[{map:map}]);
                    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
                    if (!Hafas.Config.Print.showMaps) {
                      Hafas.ps.pub('/printConfigurator/toggleMap', [{
                        mode: 'individual',
                        index: index,
                        show: Hafas.Config.Print.showMaps
                      }]);
                    }
                  },500);
                });

                // then the section maps
                window.setTimeout(function(){
                  Hafas('[data-map="section"]',true).forEach(function(map,index){
                    window.setTimeout(function(){
                      Hafas.ps.pub('/printConfigurator/addMap',[{map:map,index:index}]);
                      if (!Hafas.Config.Print.showMaps) {
                        Hafas.ps.pub('/printConfigurator/toggleWalkMaps', [{
                          mode: 'individual',
                          index: index,
                          show: Hafas.Config.Print.showMaps
                        }]);
                      }
                    },500);
                  });
                },2000);
              }

              // Klappbare Meldungen aufklappen, Buttons nicht nutzbar machen
              Hafas('.lyr_atomMessageExcerpt', true).forEach(function (elem) {
                // Meldungen mit abgekürztem Text
                elem.removeAttribute("onclick");
                elem.setAttribute("tabindex", -1);
                elem.setAttribute("aria-expanded", true);
                elem.addClassName("lyr_noButtonStyle");
              });
              Hafas('.lyr_atomMessageExpandCollapse', true).forEach(function (elem) {
                // Zusammengefasste Meldungen (x Meldungen vorhanden)
                elem.removeAttribute("onclick");
                elem.setAttribute("tabindex", -1);
                elem.setAttribute("aria-expanded", true);
                elem.hidden = true;
              });
              Hafas('.lyr_atomExpandableContent', true).forEach(function (elem) {
                // Eingeklappte Meldungen
                elem.removeAttribute("hidden");
              });
              Hafas('.lyr_expandableButtonIcon', true).forEach(function (elem) {
                // Aufklapppfeil an den Meldungen
                elem.hidden = true;
              });

              Hafas.ps.pub('/printConfigurator/updateToolboxPosition');

              window.setTimeout(function () {
                Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
              }, 0);

              window.setTimeout(function () {
                Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
              }, 1000);

              window.setTimeout(function () {
                Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
              }, 3000);

            });
          }

          // Show compact print view initally
          Hafas.ps.pub('/printconfigurator/setPrintViewMode', ['compact']);
        }
      });
    });
  }

  else if (printviewConfiguration === 'sq') {
    try {
      var dataObject = JSON.parse(window.opener.globalPrintObj['print_sq_' + printviewId]);

      Hafas.Modules.Loader.loadTemplateFiles(['common.html', 'common.messages.html', 'common.new.html', 'common.icons.html', 'common.product.html', 'sq.result.html'], function () {
        Hafas.Modules.Render.render({
          file: 'sq.result.print.html',
          target: 'HFS_PRINT',
          template: 'SQ_TplPrint',
          model: dataObject.resolvedData
        }, function () {
          // Grafiken werden nicht schnell genug geladen, darum automatisches Drucken erstmal deaktiviert
          //window.print();
        });

      });

    }
    catch (e) {
      printError();
    }

  }

  else if (printviewConfiguration == 'timetable') {
    try {
      var dataObject = JSON.parse(window.opener.globalPrintObj['print_timetable_' + printviewId]);

      Hafas.Modules.Loader.loadTemplateFiles(['common.html', 'common.icons.html', 'common.product.html', 'timetable.result.html', 'common.buttons.html', 'common.new.html', 'common.content.html'], function () {
        Hafas.Modules.Render.render({
          file: 'timetable.print.html',
          target: 'HFS_PRINT',
          template: 'Timetable_TplPrint',
          model: dataObject.result
        }, function () {
        });
      });
    }
    catch (e) {
      printError();
    }
  }

  /**
   * evaluates various values in order to react to them later during rendering
   * @param {object} dataObject
   */
  function prepareConnections (dataObject) {
    if (dataObject.connections) {
      for (var i=0; i < dataObject.connections.length; i++)  {
        if (dataObject.connections[i].secL) {
          for (var j=0; j < dataObject.connections[i].secL.length; j++) {
            var tmpSec = dataObject.connections[i].secL[j];
            // add flag for first/last section
            if ((j == 0) || (j == dataObject.connections[i].secL.length-1)) {
              tmpSec.isFirstLastSec = true;
            }

            if (typeof tmpSec.gis != "undefined" && typeof tmpSec.gis.segL != "undefined") {
              if ((j == 0) || (j == dataObject.connections[i].secL.length-1)) {
                // set flag for first/last section as gis
                dataObject.connections[i].hasFirstLastGis = true;
                dataObject.hasFirstLastGisGlobal = true;
              } else  {
                // set flag for transfer sections
                dataObject.connections[i].hasTransferInformation = true;
                dataObject.hasTransferInformationGlobal = true;
              }
            }

            // set flag for intermediate stops
            if (typeof tmpSec.jny != "undefined" && typeof tmpSec.jny.stopL != "undefined" && tmpSec.jny.stopL.length > 2) {
              dataObject.connections[i].hasIntermediateStops = true;
              dataObject.hasIntermediateStopsGlobal = true;
            }
          }
        }
      }
    }
  }

  function printError() {
    alert(Hafas.Modules.i18n.get('Print.t_N_ErrorWhileInitializing'));
    window.close();
  }

  function toggleMapsGlobal(checkbox){

    // alles einblenden
    if(checkbox.checked){
      Hafas('[data-map]',true).forEach(function(elem){
        elem.removeAttribute('hidden');

        // ggf. karten initialisieren
        Hafas('[data-map]', true).forEach(function (map, index) {
          if(Hafas.Modules.Maps.getMapById(map['id']) === false) {
            Hafas.ps.pub('/printConfigurator/addMap', [{map: map}]);
            Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
          }
        });


      });
      Hafas('.tb_mapButtons.tb_toggleButton').forEach(function(elem){
        elem.removeAttribute('hidden');
      });
    }
    // alles ausblenden
    else{
      Hafas('[data-map]',true).forEach(function(elem){
        elem.hidden = true;
      });
      Hafas('.tb_mapButtons.tb_toggleButton').forEach(function(elem){
        elem.hidden = true;
      });
    }

    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
  }
  Hafas.ps.sub('/printConfigurator/toggleMapsGlobal', toggleMapsGlobal);


  function toggleDetailSettings(boolval){
    Hafas.Util.gui.setVisibility(Hafas('#printConfiguratorDetailOptions',false),boolval);
    if(!boolval) {
      Hafas('#HFS_printConfigurator', false).addClassName('lyr_hidePrintToolboxes');
      Hafas('#HFS_printContent',false).addClassName('lyr_hidePrintDetails');
    }else{
      Hafas('#HFS_printConfigurator', false).removeClassName('lyr_hidePrintToolboxes');
      Hafas('#HFS_printContent',false).removeClassName('lyr_hidePrintDetails');
    }
  }
  Hafas.ps.sub('/printconfigurator/toggleDetailSettings',toggleDetailSettings);

  /* ein-/ausblenden der tarifdetails */
  var toggleTariffDetails = function(index){
    var tarifDetailsElem = Hafas('#HFS_printContent_'+index+' > .lyr_tarifDetails');
    var tarifDetailsVis = Hafas.Util.gui.getVisibility(tarifDetailsElem);
    Hafas.Util.gui.setVisibility(tarifDetailsElem,!tarifDetailsVis);
    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
  };
  Hafas.ps.sub('/printConfigurator/toggleTariffDetails', function(obj){
    toggleTariffDetails(obj.index);
  });

  /* ein-/ausblenden der abschnittsdetails (karte, etc.) */
  var toggleSectionDetails = function(connIdx,sectionIdx){
    Hafas('#HFS_printContent_'+connIdx+' .lyr_routeSections .lyr_conSection.lyr_section_'+sectionIdx).toggleClassName('hiddenDetails');
    Hafas('#HFS_printConnectionToolbox_'+connIdx+' .lyr_tb_detailsSection.section_'+sectionIdx).toggleClassName('hiddenDetails');

    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');

    Hafas('#HFS_printContent_'+connIdx+' .lyr_routeSections .lyr_conSection.lyr_section_'+sectionIdx+' [data-map="section"]',true).forEach(function(elem){
      if(Hafas.Modules.Maps.getMapById(elem.id)){
        Hafas.Modules.Maps.getMapById(elem.id).updateSize();
        Hafas('#tb_printMap_tb_mapToggler_'+connIdx+'_'+sectionIdx+'_resetCheckbox').click();
      }
    });
  };
  Hafas.ps.sub('/printConfigurator/toggleSectionDetails', function(obj){
    toggleSectionDetails(obj.index,obj.sectionIndex);
  });

  /* ein-/ausblenden der spaeteren fahrten */
  var toggleAlternatives = function(connIdx,sectionIdx){
    toggleRandomContainer(Hafas('#HFS_printContent_'+connIdx+' .lyr_alternatives.lyr_moreDetailsContent.alternatives_'+sectionIdx));
    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
  };
  Hafas.ps.sub('/printConfigurator/toggleAlternatives', function(obj){
    toggleAlternatives(obj.index,obj.sectionIndex);
  });

  /* ein-/ausblenden zusatzinfos */
  var toggleProductDetails = function(connIdx,sectionIdx){
    toggleRandomContainer(Hafas('#HFS_printContent_'+connIdx+' .lyr_productDetails.lyr_moreDetailsContent.productDetails_'+sectionIdx));

    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
  };
  Hafas.ps.sub('/printConfigurator/toggleProductDetails', function(obj){
    toggleProductDetails(obj.index,obj.sectionIndex);
  });

  var toggleRandomContainer = function(dom){
    var visState = Hafas.Util.gui.getVisibility(dom);
    Hafas.Util.gui.setVisibility(dom,!visState);
  }

  /* karte adden */
  var addMap = function (par) {
    var map = par.map;

    var initCoord = Hafas.Core.newType("hafasCCoord", {
      lon: Hafas.Config.Maps.predefinedArea.lon,
      lat: Hafas.Config.Maps.predefinedArea.lat
    });
    var mapConfigParams = {
      coord: initCoord,
      zoom: Hafas.Config.Maps.predefinedZoom,
      reverseLookup: false,
      layer: [{
        "name": "HAFAS BaseLayer",
        "id": "HafasBaseMap",
        "type": "static",
        "url": Hafas.Config.Maps.staticTileURL,
        "attribution": "&copy; OpenStreetMap contributors",
        "isBaseLayer": true
      }],
      baseLayer: Hafas.Config.Maps.baseLayer
    };



    var newMap;
    if(Hafas.Modules.Maps.getMapById(map['id']) === false) {
      newMap = Hafas.Core.newType("hafasMap" + Hafas.Config.Maps.mapApi, map['id'], mapConfigParams);
    }else{
      newMap = Hafas.Modules.Maps.getMapById(map['id']);
    }
    Hafas.Modules.Maps.addMap(map['id'], newMap);

    var connIdx = map.getAttribute('data-map-connection-index');
    var conn = dataObject.connections[connIdx];
    var opts = {
      centerRoute: false
    };

    if (map.getAttribute('data-map') === 'overview') {
      opts.centerRoute=true;
    }

    newMap.connection = Hafas.Core.newType("hafasConnection", conn, newMap, {});
    newMap.connection.show(opts);

    // falls gis routen nachgeladen werden, muss im html anschliessend der button fuer turn by turn eingefuegt werden
    Hafas.ps.sub('/connection/gisRouteReceived/' + map['id'], function (obj,data) {
      Hafas.ps.pub('/printConfigurator/updateToolboxContent');
      Hafas.ps.pub('/printConfigurator/addPrintInformationToGis', [connIdx,data.secIdx,obj]);
    });

    Hafas.ps.sub('/printConfigurator/addPrintInformationToGis', function(connIdx,secIdx,obj){
      // Render nachgeladene Segment-Liste
      var target = Hafas('#HFS_directions_' + connIdx + '_' + secIdx,false);
       Hafas.Modules.Render.render({
         file: 'tp.print_configurator.html',
         target: target,
         template: 'TP_TplPrintSectionSegList',
         model: obj
       }, function () {

       });
    });


    // Elemente mit initial gesetztem Tabindex bzw. Links innerhalb der Karte nicht antabbar machen (tabindex -1)
    function setTabindex(element) {
      element.setAttribute('tabindex', '-1');
    }
    var matchingElements = Hafas('.lyr_map [tabindex="0"], .lyr_map a');
    matchingElements.forEach(setTabindex);


    // Art der Karte
    // Uebersicht
    if (map.getAttribute('data-map') === 'overview') {
      // Checkbox zur Groesse setzen
      var mapWrapper = Hafas('#HFS_printOverviewMap_' + connIdx + '_wrapper');
      // Individuelle Verbindungstoolbox (pro Verbindung ein Schalter)
      if (Hafas.Config.Print.showSettingsForIndividualConnection == true && typeof Hafas('#HFS_printConfiguratorTools_' + connIdx) != 'undefined') {
        if (mapWrapper.getAttribute('data-size') === 'small') {
          Hafas('#HFS_JourneyPrintDetails_map_Mini_' + connIdx).checked = true;
        } else {
          Hafas('#HFS_JourneyPrintDetails_map_Maxi_' + connIdx).checked = true;
        }
      // Globale Verbindungstoolbox (ein Schalter für alle Verbindungen)
      } else if (typeof Hafas('#printConfiguratorDetailOptions') != 'undefined') {
        // Globale Schalterung laeuft initial immer mit kleiner Karte, darum ist hier nichts zu tun
      }
      Hafas.ps.pub('/printConfigurator/resetMap', [{index: connIdx}]);
    }

    // Section
    else if (map.getAttribute('data-map') === 'section') {
      var secIdx = parseInt(map.getAttribute('data-map-section-index'), 10);
      var secType = map.getAttribute('data-map-secType');

      // Checkbox zur Groesse setzen
      var mapWrapper = Hafas('#HFS_printSectionMap_' + connIdx + '_' + secIdx + '_wrapper');
      var mapToggler = Hafas('#tb_minimizeMapCheckbox_tb_mapToggler_' + connIdx + '_' + secIdx);
      if(mapToggler) {
        if (mapWrapper.getAttribute('data-size') === 'small') {
          mapToggler.checked = true;
        } else {
          mapToggler.checked = true;
        }
      }

      try {
        Hafas.ps.pub('/printConfigurator/resetMap', [{index: connIdx, sectionIndex: secIdx, secType: secType}]);
      }
      catch (e) {
        Hafas.logger.warn(Hafas.logger.ERROR_TYPES.JS, "print.resetmap", "Karte konnte nicht resettet werden.", e);
      }
    }

    // Segment
    else if (map.getAttribute('data-map') === 'segment') {
      var secIdx = parseInt(map.getAttribute('data-map-section-index'), 10);
      var segIdx = parseInt(map.getAttribute('data-map-segment-index'), 10);

      // Checkbox zur Groesse setzen
      var mapWrapper = Hafas('#HFS_printSegmentMap_' + connIdx + '_' + secIdx + '_' + segIdx + '_wrapper');
      if (mapWrapper.getAttribute('data-size') === 'small') {
        Hafas('#tb_minimizeMapCheckbox_tb_mapToggler_' + connIdx + '_' + secIdx + '_' + segIdx).checked = true;
      } else {
        Hafas('#tb_maximizeMapCheckbox_tb_mapToggler_' + connIdx + '_' + secIdx + '_' + segIdx).checked = true;
      }

      var polyS = map.getAttribute('data-map-poly-index-s') || '';
      var polyE = map.getAttribute('data-map-poly-index-e') || '';

      window.setTimeout(function () {
        Hafas.ps.pub('/printConfigurator/resetMap', [{
          index: connIdx,
          sectionIndex: secIdx,
          segmentIndex: segIdx,
          polyS: polyS,
          polyE: polyE
        }]);
      }, 10);
    }

    // Map Change Subscriben
    Hafas.ps.sub("/map/change/" + map['id'], function (obj) {
      mapChange(obj);
    });
  };
  Hafas.ps.sub('/printConfigurator/addMap', function (obj) {
    addMap(obj);
  });

  var mapChange = function (obj) {
    var map = obj.mapDiv;

    // Art der Karte
    // Uebersicht
    try {
      if (map.getAttribute('data-map') === 'overview') {
        if (!Hafas('#tb_printMap_tb_mapToggler_' + map.getAttribute('data-map-connection-index') + '_resetCheckbox').hasClassName('noChange')) {
          Hafas('#tb_printMap_tb_mapToggler_' + map.getAttribute('data-map-connection-index') + '_resetCheckbox').checked = false;
        }
      }
      // Section
      else if (map.getAttribute('data-map') === 'section') {
        if (!Hafas('#tb_printMap_tb_mapToggler_' + map.getAttribute('data-map-connection-index') + '_' + map.getAttribute('data-map-section-index') + '_resetCheckbox').hasClassName('noChange')) {
          Hafas('#tb_printMap_tb_mapToggler_' + map.getAttribute('data-map-connection-index') + '_' + map.getAttribute('data-map-section-index') + '_resetCheckbox').checked = false;
        }
      }
      // Segment
      else if (map.getAttribute('data-map') === 'segment') {
        if (!Hafas('#tb_printMap_tb_mapToggler_' + map.getAttribute('data-map-connection-index') + '_' + map.getAttribute('data-map-section-index') + '_' + map.getAttribute('data-map-segment-index') + '_resetCheckbox').hasClassName('noChange')) {
          Hafas('#tb_printMap_tb_mapToggler_' + map.getAttribute('data-map-connection-index') + '_' + map.getAttribute('data-map-section-index') + '_' + map.getAttribute('data-map-segment-index') + '_resetCheckbox').checked = false;
        }
      }
    }catch(e){

    }
  };

  var resetMap = function (checkboxElem, connIdx, sectionIdx, segmentIdx, polyS, polyE, secType) {

    // unnoetige clicks auf die checkbox abfangen
    if (typeof checkboxElem != 'undefined') {
      if (!checkboxElem.checked) {
        checkboxElem.checked = true;
      }
    }

    // segment
    if (typeof segmentIdx != 'undefined') {
      //window.setTimeout(function () {
        Hafas('#tb_printMap_tb_mapToggler_' + connIdx + '_' + sectionIdx + '_' + segmentIdx + '_resetCheckbox').addClassName('noChange');
        Hafas.Modules.Maps.getMapById('HFS_MapDiv_printSegmentMap_' + connIdx + '_' + sectionIdx + '_' + segmentIdx).connection.centerToSegment({
          secIdx: sectionIdx,
          polyS: polyS,
          polyE: polyE
        });
        window.setTimeout(function () {
          Hafas('#tb_printMap_tb_mapToggler_' + connIdx + '_' + sectionIdx + '_' + segmentIdx + '_resetCheckbox').removeClassName('noChange');
        }, 1000);
      //}, 1000);
    }

    // section
    else if (typeof sectionIdx != 'undefined') {
      //Hafas('#tb_printMap_tb_mapToggler_' + connIdx + '_' + sectionIdx + '_resetCheckbox').addClassName('noChange');
      var containerIdPart = (secType === "TRSF") ? 'Transfer' : '';
      try {
        window.setTimeout(function() {
          var mapInstance = Hafas.Modules.Maps.getMapById('HFS_MapDiv_printSection' + containerIdPart + 'Map_' + connIdx + '_' + sectionIdx);
          if (mapInstance !== false) {
            mapInstance.connection.centerToSection(sectionIdx);
          }
        },0);
      }
      catch (e) {
      }
      window.setTimeout(function () {
        //Hafas('#tb_printMap_tb_mapToggler_' + connIdx + '_' + sectionIdx + '_resetCheckbox').removeClassName('noChange');
      }, 1000);
    }

    // overview
    else if (typeof connIdx != 'undefined') {
      // TODO MGAB
      //Hafas('#tb_printMap_tb_mapToggler_' + connIdx + '_resetCheckbox').addClassName('noChange');
      Hafas.Modules.Maps.getMapById('HFS_MapDiv_printOverviewMap_' + connIdx).connection.centerRoute();
      window.setTimeout(function () {
        //Hafas('#tb_printMap_tb_mapToggler_' + connIdx + '_resetCheckbox').removeClassName('noChange');
      }, 1000);
    }


  };
  Hafas.ps.sub('/printConfigurator/resetMap', function (obj) {
    resetMap(obj.elem, obj.index, obj.sectionIndex, obj.segmentIndex, obj.polyS, obj.polyE, obj.secType);
  });

  /* overlays auf den karten, wenn �ber ein toolbox-button gehovered wird */
  var hoverMapToolboxButton = function (params) {

    // segment
    if (typeof params.segmentIndex !== 'undefined') {
      Hafas('#HFS_printSegmentMap_' + params.index + '_' + params.sectionIndex + '_' + params.segmentIndex + '_wrapper .lyr_toolboxActionLayer').setAttribute('data-overlay', params.method);
    }

    // section
    else if (typeof params.sectionIndex !== 'undefined') {
      Hafas('#HFS_printSectionMap_' + params.index + '_' + params.sectionIndex + '_wrapper .lyr_toolboxActionLayer').setAttribute('data-overlay', params.method);
    }

    // overview
    else if (typeof params.index !== 'undefined') {
      Hafas('#HFS_printOverviewMap_' + params.index + '_wrapper .lyr_toolboxActionLayer').setAttribute('data-overlay', params.method);
    }

  };
  Hafas.ps.sub('/printConfigurator/hoverMapToolboxButton', function (obj) {
    hoverMapToolboxButton(obj);
  });


  var unhoverMapToolboxButton = function (params) {

    // segment
    if (typeof params.segmentIndex != 'undefined') {
      Hafas('#HFS_printSegmentMap_' + params.index + '_' + params.sectionIndex + '_' + params.segmentIndex + '_wrapper .lyr_toolboxActionLayer').setAttribute('data-overlay', '');
    }

    // section
    else if (typeof params.sectionIndex != 'undefined') {
      Hafas('#HFS_printSectionMap_' + params.index + '_' + params.sectionIndex + '_wrapper .lyr_toolboxActionLayer').setAttribute('data-overlay', '');
    }

    // overview
    else if (typeof params.index != 'undefined') {
      Hafas('#HFS_printOverviewMap_' + params.index + '_wrapper .lyr_toolboxActionLayer').setAttribute('data-overlay', '');
    }

  };
  Hafas.ps.sub('/printConfigurator/unhoverMapToolboxButton', function (obj) {
    unhoverMapToolboxButton(obj);
  });

  /* kartenlayer */
  var setMapLayer = function(layer,connIdx,sectionIdx,segmentIdx){
    var mapObj;

    // segment
    if(typeof segmentIdx !== 'undefined'){
      mapObj = Hafas.Modules.Maps.getMapById('HFS_MapDiv_printSegmentMap_'+connIdx+'_'+sectionIdx+'_'+segmentIdx);
    }

    // section
    else if(typeof sectionIdx !== 'undefined'){
      mapObj = Hafas.Modules.Maps.getMapById('HFS_MapDiv_printSectionMap_'+connIdx+'_'+sectionIdx);
    }

    // overview
    else if(typeof connIdx !== 'undefined'){
      mapObj = Hafas.Modules.Maps.getMapById('HFS_MapDiv_printOverviewMap_'+connIdx);
    }

    if(mapObj){
      mapObj.hideAllBaseLayers();
      layer.forEach(function(elem){
        mapObj.showBaseLayerById(elem);
      });
    }

  };
  Hafas.ps.sub('/printConfigurator/setMapLayer', function(obj){
    setMapLayer(obj.layer,obj.index,obj.sectionIndex,obj.segmentIndex);
  });

  /* karte groß/klein */
  var toggleMapSize = function (connIdx, sectionIdx, segmentIdx, polyS, polyE,action, secType) {

    var containerIdPart = secType || '';
    var mapWrapperElem;

    // segment
    if (typeof segmentIdx !== 'undefined' && segmentIdx != null) {

      var segmentElem = Hafas('#HFS_printContent_' + connIdx + ' .lyr_routeSections .lyr_conSection.lyr_section_' + sectionIdx + ' .lyr_directionWrapper_' + segmentIdx);
      mapWrapperElem = Hafas('#HFS_printSegmentMap_' + connIdx + '_' + sectionIdx + '_' + segmentIdx + '_wrapper');
      var tmpMapDiv = Hafas('#HFS_MapDiv_printSegmentMap_' + connIdx + '_' + sectionIdx + '_' + segmentIdx);

      if (mapWrapperElem && mapWrapperElem.getAttribute('data-size') === 'small') {
        segmentElem.removeClassName('smallMap');
        segmentElem.addClassName('largeMap');
      }
      else {
        segmentElem.addClassName('smallMap');
        segmentElem.removeClassName('largeMap');
      }

      Hafas.Modules.Maps.getMapById('HFS_MapDiv_printSegmentMap_' + connIdx + '_' + sectionIdx + '_' + segmentIdx).updateSize();
      Hafas.ps.pub('/printConfigurator/resetMap',[{elem:this,index:connIdx,sectionIndex:sectionIdx,segmentIndex:segmentIdx,polyS:polyS,polyE:polyE}]);
    }

    // section
    else if (typeof sectionIdx !== 'undefined' && sectionIdx != null) {
      mapWrapperElem = Hafas('#HFS_printSection' + containerIdPart + 'Map_' + connIdx + '_' + sectionIdx + '_wrapper');
      var mapSectionContainer = Hafas('#HFS_printContent_' + connIdx + ' .lyr_section_' + sectionIdx);
      var sectionDirectionsWrapper = null;
      if (mapWrapperElem) {
        sectionDirectionsWrapper = mapWrapperElem.closest('.lyr_sectionDirectionsWrapper');
        if (mapWrapperElem.getAttribute('data-size') === 'small' && ((action === undefined || action === 'maximize') || (action !== undefined && action === 'maximize'))) {
          // Size === small
          if (mapSectionContainer !== null) {
            mapSectionContainer.removeClassName('smallMap');
            mapSectionContainer.addClassName('largeMap');
          }
          if (sectionDirectionsWrapper !== null) {
            sectionDirectionsWrapper.addClassName('largeMap');
          }
          mapWrapperElem.setAttribute('data-size', 'large');
        } else if (mapWrapperElem.getAttribute('data-size') === 'large' && ((action === undefined || action === 'minimize') || (action !== undefined && action === 'minimize'))) {
          // Size !== small
          if (mapSectionContainer !== null) {
            mapSectionContainer.addClassName('smallMap');
            mapSectionContainer.removeClassName('largeMap');
          }
          if (sectionDirectionsWrapper !== null) {
            sectionDirectionsWrapper.removeClassName('largeMap');
          }
          mapWrapperElem.setAttribute('data-size', 'small');
        }
      }

      var mapInstance = Hafas.Modules.Maps.getMapById('HFS_MapDiv_printSection' + containerIdPart + 'Map_' + connIdx + '_' + sectionIdx);
      if (mapInstance != false) {
        mapInstance.updateSize();
      }
      Hafas.ps.pub('/printConfigurator/resetMap',[{elem:this,index:connIdx,sectionIndex:sectionIdx,secType:containerIdPart}]);
    }

    // overview
    else if (typeof connIdx !== 'undefined' && connIdx != null) {
      mapWrapperElem = Hafas('#HFS_printOverviewMap_' + connIdx + '_wrapper');

      if ((mapWrapperElem.getAttribute('data-size') === 'small' && (action == undefined || action == 'maximize')) || (action !== undefined && action == 'maximize')) {
        Hafas('#HFS_printContent_' + connIdx + ' .lyr_mapAndSummaryWrapper').removeClassName('smallMap');
        Hafas('#HFS_printContent_' + connIdx + ' .lyr_mapAndSummaryWrapper').addClassName('largeMap');
        mapWrapperElem.setAttribute('data-size', 'large');
      }
      else {
        Hafas('#HFS_printContent_' + connIdx + ' .lyr_mapAndSummaryWrapper').addClassName('smallMap');
        Hafas('#HFS_printContent_' + connIdx + ' .lyr_mapAndSummaryWrapper').removeClassName('largeMap');
        mapWrapperElem.setAttribute('data-size', 'small');
      }

      Hafas.Modules.Maps.getMapById('HFS_MapDiv_printOverviewMap_' + connIdx).updateSize();
      Hafas.Modules.Maps.getMapById('HFS_MapDiv_printOverviewMap_' + connIdx).connection.centerRoute();

    }


    // toolbox ausrichten
    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
  };
  Hafas.ps.sub('/printConfigurator/toggleMapSize', function (obj) {
    if (obj.mode === 'global'){
      for(var d=0; d < dataObject.connections.length;d++) {
        toggleMapSize(d,obj.sectionIndex, obj.segmentIndex, obj.polyS, obj.polyE, obj.action);
      }
    } else {
      toggleMapSize(obj.index, obj.sectionIndex, obj.segmentIndex, obj.polyS, obj.polyE, obj.action, obj.secType);
    }
  });

  function toggleWalkMapSizeForConnection(currentConnection, index, obj){

    var containerIdPart = obj.secType || '';
    for (var s = 0; s < currentConnection.secL.length; s++) {
      var tmpSection = currentConnection.secL[s];
      if ((tmpSection.type === 'WALK' || tmpSection.type === 'TRSF') && tmpSection.gis !== undefined && tmpSection.gis.segL !== undefined && currentConnection.secL.length > 1) {
        toggleMapSize(index, s, null, null, null, obj.action, containerIdPart);
        var mapInstance = Hafas.Modules.Maps.getMapById('HFS_MapDiv_printSection' + containerIdPart + 'Map_' + index + '_' + s);
        if (mapInstance !== false) {
          mapInstance.connection.centerToSection(s);
        }
      }
    }
  }

  Hafas.ps.sub('/printConfigurator/toggleWalksMapSize', function(obj){
    var currentConnection;
    if(obj.mode === 'global'){
      for(var d=0; d < dataObject.connections.length;d++) {
        currentConnection = dataObject.connections[d];
        toggleWalkMapSizeForConnection(currentConnection, d , obj);
      }
    }else {
      currentConnection = dataObject.connections[obj.index];
      toggleWalkMapSizeForConnection(currentConnection,obj.index,obj);
    }
  });

  /* ein-/ausblenden karten */
  var toggleMap = function (connIdx, sectionIdx, segmentIdx, polyS, polyE, secType) {
    // segment
    if (typeof segmentIdx !== 'undefined' && segmentIdx !== null) {
      Hafas('#HFS_printContent_' + connIdx + ' .lyr_routeSections .lyr_conSection.lyr_section_' + sectionIdx + ' .lyr_directionWrapper_' + segmentIdx).toggleClassName('hiddenMap');
      Hafas('#tb_mapToggler_' + connIdx + '_' + sectionIdx + '_' + segmentIdx).toggleClassName('mapDisabled');

      // erst noch initialisieren?
      var mapDiv = Hafas('#HFS_directions_'+connIdx+'_'+sectionIdx+' [data-map-segment-index="'+segmentIdx+'"]',false);
      if(mapDiv && mapDiv.getAttribute('data-map-async')){
        mapDiv.removeAttribute('data-map-async');
        Hafas.ps.pub('/printConfigurator/addMap',[{map:mapDiv}]);
      }
      var mapContainer = Hafas('#HFS_MapDiv_printSegmentMap_' + connIdx + '_' + sectionIdx + '_'+ segmentIdx,false);
      var mapContainerVis = Hafas.Util.gui.getVisibility(mapContainer);
      Hafas.Util.gui.setVisibility(mapContainer,!mapContainerVis);
      Hafas.Modules.Maps.getMapById('HFS_MapDiv_printSegmentMap_' + connIdx + '_' + sectionIdx + '_'+ segmentIdx).updateSize();
      Hafas.ps.pub('/printConfigurator/resetMap',[{elem:this,index:connIdx,sectionIndex:sectionIdx,segmentIndex:segmentIdx,polyS:polyS,polyE:polyE}]);

    }

    // section
    else if (typeof sectionIdx !== 'undefined') {
      var sectionContainer = Hafas('#HFS_printContent_' + connIdx + ' .lyr_routeSections .lyr_conSection.lyr_section_' + sectionIdx);
      if(sectionContainer) {
        sectionContainer.toggleClassName('hiddenMap');
      }
      //Hafas('#tb_mapToggler_' + connIdx + '_' + sectionIdx).toggleClassName('mapDisabled');
      var containerIdPart = secType || '';
      var mapContainer = Hafas('#HFS_MapDiv_printSection' + containerIdPart + 'Map_' + connIdx + '_' + sectionIdx);
      var mapVis = Hafas.Util.gui.getVisibility(mapContainer);
      Hafas.Util.gui.setVisibility(mapContainer,!mapVis);

      var mapInstance = Hafas.Modules.Maps.getMapById('HFS_MapDiv_printSection' + containerIdPart + 'Map_' + connIdx + '_' + sectionIdx);
      if (mapInstance !== false) {
        mapInstance.updateSize();
      }
      // todo: Erweiterung übergeben
      Hafas.ps.pub('/printConfigurator/resetMap',[{elem:this,index:connIdx,sectionIndex:sectionIdx,secType:containerIdPart}]);
    }

    // overview
    else if (typeof connIdx !== 'undefined') {
      var mapSummaryWrapper = Hafas('#HFS_printContent_' + connIdx + ' .lyr_mapAndSummaryWrapper');
      var mapMaxiContainer = Hafas('#HFS_JourneyPrintDetails_map_Maxi_' + connIdx);
      var mapMiniContainer = Hafas('#HFS_JourneyPrintDetails_map_Mini_' + connIdx);
      var mapMiniGlobal = Hafas('#HFS_JourneyPrintDetails_map_Mini_Global');
      var mapMaxiGlobal = Hafas('#HFS_JourneyPrintDetails_map_Maxi_Global');
      if (mapSummaryWrapper && mapSummaryWrapper.hasClassName('hiddenMap')) {
        mapSummaryWrapper.removeClassName('hiddenMap');
        mapSummaryWrapper.addClassName(Hafas('#HFS_printOverviewMap_' + connIdx + '_wrapper').getAttribute('data-size') + 'Map');
        //Hafas('#tb_mapToggler_' + connIdx).removeClassName('mapDisabled');
        if (mapMiniContainer) {
          mapMiniContainer.disabled = false;
        } else {
          if (mapMiniGlobal) {
            mapMiniGlobal.disabled = false;
          }
        }
        if (mapMaxiContainer) {
          mapMaxiContainer.disabled = false;
        } else {
          if (mapMaxiGlobal) {
            mapMaxiGlobal.disabled = false;
          }
        }
      } else {
        if (mapSummaryWrapper) {
          mapSummaryWrapper.removeClassName('smallMap');
          mapSummaryWrapper.removeClassName('largeMap');
          mapSummaryWrapper.addClassName('hiddenMap');
        }
        //Hafas('#tb_mapToggler_' + connIdx).addClassName('mapDisabled');
        if (mapMiniContainer) {
          mapMiniContainer.disabled = true;
        } else {
          if (mapMiniGlobal) {
            mapMiniGlobal.disabled = true;
          }
        }
        if (mapMaxiContainer) {
          mapMaxiContainer.disabled = true;
        } else {
          if (mapMaxiGlobal) {
            mapMaxiGlobal.disabled = true;
          }
        }
      }
    }

    // toolbox ausrichten
    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
  };
  Hafas.ps.sub('/printConfigurator/toggleMap', function (obj) {
    if(obj.mode == 'global'){
      for(var d=0; d < dataObject.connections.length;d++){
        toggleMap(d);
      }
    }else {
      toggleMap(obj.index, obj.sectionIndex, obj.segmentIndex, obj.polyS, obj.polyE);
    }
  });

  function toggleWalkMaps(obj){

    if(obj.mode == 'global'){
        var tmpArray = dataObject.connections;
    }else{
        var tmpArray = [dataObject.connections[obj.index]]
    }
    var secTypeStr = obj.secType || "";
    var togglerIdSecType = (secTypeStr === 'Transfer') ? 'transfers' : 'walk';

    for (var t = 0; t < tmpArray.length; t++) {
      var _connection = tmpArray[t];
      if (_connection) {
        // Iterate through all sections; if segL is available, toggle description
        for (var s = 0; s < _connection.secL.length; s++) {
          if (_connection.secL[s].gis !== undefined && _connection.secL[s].gis.segL !== undefined) {
            var mapContainer = Hafas('#HFS_printSection' + secTypeStr + 'Map_' + _connection.connIdx + '_' + s + '_wrapper', false);

            if (mapContainer) {
            var _domDirectionsWrapper = mapContainer.closest('.lyr_sectionDirectionsWrapper');

              if (typeof obj.secType != "undefined") {
                toggleMap(_connection.connIdx, s, null, null, null, obj.secType);
              } else {
                toggleMap(_connection.connIdx, s);
              }
              var show = obj.show || (Hafas.Util.gui.getVisibility(mapContainer) == false);
              if (show) {
                Hafas.Util.gui.setVisibility(mapContainer, true);
                _domDirectionsWrapper.addClassName('lyr_hideDirectionsMap')
                var map = Hafas.Modules.Maps.getMapById('HFS_MapDiv_printSection' + secTypeStr + 'Map_' + _connection.connIdx + '_' + s);
                if (map) {
                  map.updateSize();
                  map.connection.centerToSection(s);
                }
              } else {
                Hafas.Util.gui.setVisibility(mapContainer, false);
                _domDirectionsWrapper.removeClassName('lyr_hideDirectionsMap')
              }
            }
          }
        }
        var mapToggleButtonSuffix = (obj.mode == 'global') ? "Global" : _connection.connIdx;
        // switches for each journey
        var miniButton = Hafas('#HFS_JourneyPrintDetails_map_' + togglerIdSecType + '_Mini_' + mapToggleButtonSuffix, false);
        var maxiButton = Hafas('#HFS_JourneyPrintDetails_map_' + togglerIdSecType + '_Maxi_' + mapToggleButtonSuffix, false);
        // global switch one for each journey
        if(!miniButton) miniButton = Hafas('#HFS_JourneyPrintDetails_map_walk_Mini_Global');
        if(!maxiButton) maxiButton = Hafas('#HFS_JourneyPrintDetails_map_walk_Maxi_Global');
        if (typeof obj.show != 'undefined' && obj.show == false) {
          //HFS_JourneyPrintDetails_map_walk_Mini_Global
          if (miniButton) miniButton.disabled = true;
          if (maxiButton) maxiButton.disabled = true;
        } else {
          if (miniButton) miniButton.disabled = false;
          if (maxiButton) maxiButton.disabled = false;
        }
      }
    }
    //toggleMap(obj.index, obj.sectionIndex, obj.segmentIndex, obj.polyS, obj.polyE);
  };
  Hafas.ps.sub('/printConfigurator/toggleWalkMaps', toggleWalkMaps);

  /* ein-/ausblenden der verbindungsdetails */
  var toggleConnectionDetails = function(index){
    Hafas('#HFS_printContent_'+index+' > .lyr_routeSections').toggleClassName('hiddenDetails');
    Hafas('#HFS_printConnectionToolbox_'+index+' > .lyr_tb_detailsWrapper').toggleClassName('hiddenDetails');
    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
    Hafas.ps.pub('/printConfigurator/updateToolboxContent', [index]);

    Hafas('#printContent_'+index+' > .lyr_routeSections [data-map="section"]',true).forEach(function(elem,sectIdx){
      if(Hafas.Modules.Maps.getMapById(elem.id)){
        Hafas.Modules.Maps.getMapById(elem.id).updateSize();
        Hafas('#tb_printMap_'+index+'_'+sectIdx+'_resetCheckbox').click();
      }
    });
  };
  Hafas.ps.sub('/printConfigurator/toggleConnectionDetails', function(obj){
    toggleConnectionDetails(obj.index);
  });

  /* ein-/ausblenden der abbiegehinweise/turn by turn */
  var toggleDirections = function (connIdx, sectionIdx,show) {

    if(show){
      Hafas('#HFS_printDirectionsPlaceholder_'+connIdx+'_'+sectionIdx).removeAttribute('hidden');
    }
    else{
      Hafas('#HFS_printDirectionsPlaceholder_'+connIdx+'_'+sectionIdx).hidden = true;
    }

    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
  };

  Hafas.ps.sub('/printConfigurator/toggleDirections', function (obj) {
    toggleDirections(obj.index, obj.sectionIndex);
  });

  var toggleTurnByTurn = function(options){

    // Alle Verbindungen /globale Schalterung)
    if (options.mode == "global") {
      for (var c = 0; c < dataObject.connections.length; c++) {
        var _connection = dataObject.connections[c];
        // Iterate through all sections; if segL is available, toggle description
        for (var s = 0; s < _connection.secL.length; s++) {
          if (_connection.secL[s].gis !== undefined && _connection.secL[s].gis.segL !== undefined && typeof _connection.secL[s].isFirstLastSec != 'undefined') {
            toggleDirections(c, s, options.show);
          }
        }
      }

    // Einzelverbindung
    } else {
      var _connection = dataObject.connections[options.connectionIdx];
      // Iterate through all sections; if segL is available, toggle description
      for (var s=0; s < _connection.secL.length;s++) {
        if (_connection.secL[s].gis !== undefined && _connection.secL[s].gis.segL !== undefined && typeof _connection.secL[s].isFirstLastSec != 'undefined') {
          toggleDirections(options.connectionIdx, s, options.show);
        }
      }
    }
    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
  };
  Hafas.ps.sub('/printconfigurator/toggleTurnByTurn',toggleTurnByTurn);

  // Toggeln der Umstiege
  var toggleTransfers = function(options) {
    if (options.mode == "global") {
      var conIdxArr = [];
      for (var i=0; i < dataObject.connections.length; i++) {
        conIdxArr.push(i);
      }
    } else {
      var conIdxArr = [options.connectionIdx];
    }
    for (var c=0; c < conIdxArr.length; c++) {
      if (typeof conIdxArr[c] != 'undefined') {
        var _currentConnectionBlock = Hafas("#HFS_printContent_" + conIdxArr[c]);
        var transferRows = _currentConnectionBlock.querySelectorAll(".lyr_isTransferSection");
        for (var i = 0; i < transferRows.length; i++) {
          if (options.show) {
            transferRows[i].removeAttribute('hidden');
          } else {
            transferRows[i].hidden = true;
          }
        }
      }
    }
    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
  };
  Hafas.ps.sub('/printconfigurator/toggleTransfers', toggleTransfers);

  var toggleIntermediateStops = function(options){
    if (options.mode == "global") {
      var conIdxArr = [];
      for (var i=0; i < dataObject.connections.length; i++) {
        conIdxArr.push(i);
      }
    } else {
      var conIdxArr = [options.connectionIdx];
    }
    for (var c=0; c < conIdxArr.length; c++) {
      if (typeof conIdxArr[c] != 'undefined') {
        var _currentConnectionBlock = Hafas('#HFS_printContent_' + conIdxArr[c]);
        var intermediateStopsRows = _currentConnectionBlock.querySelectorAll('.lyr_conSectionIntermediate');
        for (var i = 0; i < intermediateStopsRows.length; i++) {
          if (options.show) {
            intermediateStopsRows[i].removeAttribute('hidden');
          } else {
            intermediateStopsRows[i].hidden = true;
          }
        }
        var departureRows = _currentConnectionBlock.querySelectorAll('.lyr_conSectionDeparture.lyr_conSectionIsJny');
        for (var i = 0; i < departureRows.length; i++) {
          var productCell = departureRows[i].querySelectorAll('.lyr_product');
          var durationCell = departureRows[i].querySelectorAll('.lyr_duration');
          if (options.show) {
            productCell[0].removeClassName('lyr_tdAbsoluteWrapper');
            durationCell[0].removeClassName('lyr_tdAbsoluteWrapper');
          } else {
            productCell[0].addClassName('lyr_tdAbsoluteWrapper');
            durationCell[0].addClassName('lyr_tdAbsoluteWrapper');
          }
        }
      }
    }
    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
  };
  Hafas.ps.sub('/printconfigurator/toggleIntermediateStops', toggleIntermediateStops);


  /* ein-/ausblenden ergebnise */
  var togglePrintConnection = function(index){
    var connectionWrapperElem = Hafas('#HFS_multiPrintConnectionWrapper_'+index);
    var connectionVis = Hafas.Util.gui.getVisibility(connectionWrapperElem);
    Hafas.Util.gui.setVisibility(connectionWrapperElem,!connectionVis);

    var toolboxWrapperElem = Hafas('#HFS_printConnectionToolbox_'+index);
    if(toolboxWrapperElem) {
      Hafas.Util.gui.setVisibility(toolboxWrapperElem, !connectionVis);
    }

    Hafas('#HFS_printConnection_'+index).toggleClassName('lyr_fadedPrint');
    Hafas('#HFS_printConnection_'+index).toggleClassName('lyr_noPrint');
    Hafas.ps.pub('/printConfigurator/updateToolboxPosition');
    Hafas.ps.pub('/printConfigurator/updateToolboxContent', [index]);

    Hafas('#multiPrintConnectionWrapper_'+index+' [data-map="overview"]',true).forEach(function(elem){
      if(Hafas.Modules.Maps.getMapById(elem.id)){
        Hafas.Modules.Maps.getMapById(elem.id).updateSize();
        //Hafas('#tb_printMap_tb_mapToggler_'+index+'_resetCheckbox').click();
        Hafas.Modules.Maps.getMapById(elem.id).connection.centerRoute();
      }
    });
    Hafas('#multiPrintConnectionWrapper_'+index+' [data-map="section"]',true).forEach(function(elem){
      if(Hafas.Modules.Maps.getMapById(elem.id)){
        Hafas.Modules.Maps.getMapById(elem.id).updateSize();
        var sectionIndex = elem.getAttribute("data-map-section-index");
        Hafas.Modules.Maps.getMapById(elem.id).connection.centerToSection(sectionIndex);
      }
    });

    // Drucken Button deaktivieren, wenn keine Verbindung ausgewählt ist
    var allConnections = Hafas('.lyr_printConnectionWrapper');
    var mainPrintButton = Hafas("#HFS_mainPrintButton");
    var displayMainPrintButton = false;
    if (allConnections.length > 0) {
      for (var i=0; i < allConnections.length; i++) {
        if (Hafas.Util.gui.getVisibility(allConnections[i]) === true) {
          displayMainPrintButton = true;
          break;
        }
      }
    } else {
      // In der Rekonstruktion gibt es nur noch eine Verbindung
      if (Hafas.Util.gui.getVisibility(allConnections) === true) {
        displayMainPrintButton = true;
      }
    }
    if (!displayMainPrintButton) {
      mainPrintButton.setAttribute('disabled', 'disabled');
    } else {
      mainPrintButton.removeAttribute('disabled');
    }

    // Generate and show QR code if checkbox is checked
    var qrCodeCheckbox = Hafas('#HFS_Printconfigurator_details_qrcode_NaN');
    if (qrCodeCheckbox && qrCodeCheckbox.checked) {
      Hafas.ps.pub('/printConfigurator/toggleQrCode', [true]);
    }
  };
  Hafas.ps.sub('/printConfigurator/togglePrintConnection', function(obj){
    togglePrintConnection(obj.index);
  });

  function hideAdditionalDetails(boolval){
    if(!boolval){
      Hafas('#HFS_printContent').addClassName('lyr_hideAdditionalInfo');
    }else{
      Hafas('#HFS_printContent').removeClassName('lyr_hideAdditionalInfo');
    }
  }
  Hafas.ps.sub('/printConfigurator/hideAdditionalDetails', hideAdditionalDetails);

  /**
   * Create a universal search link using the current connection parameters.
   * @param {string} basePath - The base path to use for the URL.
   * @param {string} virtualClientParam - URL param for virtual client.
   * @returns {string} The search link.
   */
  function createSearchLink (basePath, virtualClientParam) {
    var query = dataObject.query;

    var dep = query.dep;
    var arr = query.arr;

    if (dep == null || arr == null)
      return basePath + '?' + virtualClientParam;

    var url = basePath + '?' + virtualClientParam + 'ulVersion=1.2&context=TP&SID=' + encodeURIComponent(dep.lid) + '&ZID=' + encodeURIComponent(arr.lid);


    if (query.outDate != null)
      url += '&date=' + Hafas.Util.date.hciDate2string(query.outDate);

    if (query.outTime != null)
      url += '&time=' + Hafas.Util.date.hciTime2string(query.outTime);

    if (query.outFrwd)
      url += '&timeSel=depart';
    else
      url += '&timeSel=arrive';

    url += '&products=' + query.cls;
    url += '&start=yes';
    return url;
  }

  /**
   * Generate a search link if multiple connections are selected, or a reconstruction link if only one connection is selected.
   * @param {function} callback - Function to call once the link has been generated.
   */
  function generateLink (callback) {
    // Find selected connections through HTML classes
    var allConnections = Hafas('.lyr_printOverviewTableRow', true);
    var inactiveConnections = Hafas('.lyr_printOverviewTableRow.lyr_noPrint', true);
    var activeConnections;

    if (inactiveConnections.length) {
      // Some connections are not selected, filter them out
      activeConnections = allConnections.filter(function (connection) {
        for (var i = 0; i < inactiveConnections.length; i++) {
          if (connection.id === inactiveConnections[i].id) {
            return false;
          }
        }
        return true;
      });
    } else {
      // There are no unselected connections
      activeConnections = allConnections;
    }

    // Generate URL
    var basePath = Hafas.Config.Services.qrCodeBasePath;
    var hasConfigBasePath = true;
    if (!basePath) {
      hasConfigBasePath = false;
      basePath = Hafas.Core.getWebAppBasePath();
    }
    var virtualClientParam = (!hasConfigBasePath && Hafas.Config.isCustomer === true) ? "L=" + Hafas.Config.CustomerName + "&" : '';
    if (activeConnections.length === 1) {
      // Only one connection selected -> reconstruction
      var activeIndex = activeConnections[0].id.split('_').pop();
      var ctx = dataObject.connections[activeIndex].recon.ctx;
      var reconCtxConverterReq = Hafas.Core.newType('hafasHCIRequestObject', 'ReconstructionContextConverter', {
        'req.mode': 'TO_STORAGE_ID',
        'req.ctxL': [ctx]
      });
      var hciReconCtxConverterReq = Hafas.Core.newType('hafasHCIRequest', {requests: [reconCtxConverterReq]});

      Hafas.Core.newType("hafasRequest", {
        request: "ReconstructionContextConverter",
        requestType: 'hci',
        hciRequestObj: hciReconCtxConverterReq,
        callback: function (data) {
          var link = '';
          if (data.svcResL && data.svcResL[0].res && data.svcResL[0].res.storageIdL) {
            var storageId = data.svcResL[0].res.storageIdL[0];
            if (storageId) {
              link = basePath + '?' + virtualClientParam + 'ulVersion=1.2&context=TP&method=storageRecon&storageId=' + storageId;
            }
          }
          callback(link);
        }
      });
    } else {
      // Multiple connections selected -> search link
      callback(createSearchLink(basePath, virtualClientParam));
    }
  }



  /**
   * Toggle the QR code and the realtime hint's visibility and regenerate the QR code if visible.
   * @param {boolean} boolval - Whether to show the QR code and hint.
   */
  function toggleQrCode (boolval) {
    var qrCodeElem = Hafas('.lyr_printQrCode');
    if (qrCodeElem) {
      generateLink(function (link) {
        // Generate QR code
        var svgAsString = '';
        if (link) {
          var qrc = qrcodegen.QrCode;
          var linkAsQrCode = qrc.encodeText(link, qrc.Ecc.LOW);
          svgAsString = Hafas.Util.qrCodeToSvgString(linkAsQrCode);
        }
        qrCodeElem.innerHTML = svgAsString;
      });
      Hafas.Util.gui.setVisibility(qrCodeElem, boolval);
    }

    var realtimeHintElem = Hafas('.lyr_printRealtimeHint');
    if (realtimeHintElem) {
      Hafas.Util.gui.setVisibility(realtimeHintElem, boolval);
    }
  }
  Hafas.ps.sub('/printConfigurator/toggleQrCode', toggleQrCode);

  function hideMessages(boolval){
    if(!boolval){
      Hafas('#HFS_printContent').addClassName('lyr_hideMessages');
    }else{
      Hafas('#HFS_printContent').removeClassName('lyr_hideMessages');
    }
  }
  Hafas.ps.sub('/printConfigurator/hideMessages', hideMessages);

  function hidePrices(boolval){
    if(!boolval){
      Hafas('#HFS_printContent').addClassName('lyr_hidePrices');
    }else{
      Hafas('#HFS_printContent').removeClassName('lyr_hidePrices');
    }
  }
  Hafas.ps.sub('/printConfigurator/hidePrices', hidePrices);

  // Umschalter von Konfigurator zu Kompaktansicht
  function setPrintViewMode(viewMode) {
    if (viewMode == "compact") {
      // Es müssen vor dem Umschalten in den Schnelldruck auf jeden Fall die Details wieder eingeschaltet werden:
      Hafas.ps.pub('/printconfigurator/toggleDetailSettings',[true]);
      var detailSettingsSwitch = Hafas('#HFS_Printconfigurator_ToggleDetails',false);
      if(detailSettingsSwitch){
        detailSettingsSwitch.checked = true;
      }

      Hafas('#HFS_PrintModeSelection_all').setAttribute('aria-selected', false);
      Hafas('#HFS_PrintModeSelection_compact').setAttribute('aria-selected', true);
      Hafas('#HFS_printContentWrapper').addClassName('lyr_compactPrintView');
    } else {
      Hafas('#HFS_PrintModeSelection_all').setAttribute('aria-selected', true);
      Hafas('#HFS_PrintModeSelection_compact').setAttribute('aria-selected', false);
      Hafas('#HFS_printContentWrapper').removeClassName('lyr_compactPrintView');
      Hafas.ps.pub('/printConfigurator/updateToolboxPosition'); // Notwendig für die Neu-Positionierung der Toolbox!
      Hafas.ps.pub('/printConfigurator/toggleMapSize',[{mode:'global',index:null, action: 'minimize'}]);
    }
  };
  Hafas.ps.sub('/printconfigurator/setPrintViewMode', setPrintViewMode);

  /**
   * renders a journeySettings Block in Toolbox, because of changing data like gisRoutes
   * @param {number} activeIndex
   */
  function renderJourneySettings(activeIndex) {

    var toolboxForJourney = Hafas('[data-render-element="printJourneySettings_'+activeIndex+'"]');
    var focusSelector = Hafas.Util.gui.getFocusElementSelector();
    Hafas.Modules.Render.render({
      file: 'tp.print_configurator.html',
      target: toolboxForJourney,
      template: 'TP_TplPrintConfigurator_Toolbox_JourneySettings',
      model: dataObject.connections[activeIndex],
      global: {index:activeIndex}
    }, function () {
      Hafas.Util.gui.restoreFocus(focusSelector);
    });
  }

  /**
   * Updates toolbox in content
   * @param index
   */
  function updateToolboxContent (index) {

    prepareConnections(dataObject);
    if (index) {
      renderJourneySettings(index)
    } else {
      dataObject.connections.forEach(function (connection, index) {
        renderJourneySettings(index);
      });
    }
  }

  Hafas.ps.sub('/printConfigurator/updateToolboxContent', updateToolboxContent);

  /**
   * Updates toolbox in position
   */
  function updateToolboxPosition() {

      var getElemOffset = function (el) {
        return {
          top: Hafas.Util.getPosY(el)
        };
      };

      var getElemOuterHeight = function (el) {
        var height = el.offsetHeight;
        var style = getComputedStyle(el);

        height += parseInt(style.marginTop) + parseInt(style.marginBottom);
        return height;
      };

      // alle platzhalter resetten
      Hafas('.adjustHelper', true).forEach(function (elem) {
         elem.style.height = '0';
       });

      // uebersicht
      // sichtbar?
      if (Hafas('.lyr_printOverviewTable').hidden) {
         Hafas('#adjustHelperOvTable').style.height = (getElemOffset(Hafas('.lyr_printConnectionWrapper')[0]).top - getElemOffset(Hafas('#printConfiguratorOvTable')).top - getElemOuterHeight(Hafas('#printConfiguratorOvTable'))) + 'px';
       } else {
         Hafas('#adjustHelperOvTable').style.height = (getElemOffset(Hafas('.lyr_printOverview')).top - getElemOffset(Hafas('#printConfiguratorOvTable')).top) + 'px';
         Hafas('#adjustHelperOvTable2').style.height = (getElemOffset(Hafas('#HFS_printConnection_0')).top - getElemOffset(Hafas('.printConfiguratorOvTableWrapper')).top) - (Hafas('#HFS_PrintConnectionChooserHeadline',false).clientHeight) + 'px';

         // hoehe der tabellenzellen
         //Hafas('#HFS_printOvTable .lyr_printOverviewTableRow', true).forEach(function (elem, index) {
         //  Hafas('#printSummaryTableRow_' + index + ' td').style.height = getElemOuterHeight(elem) + 'px';
         //});

       }

      // ergebnisse
      Hafas('.lyr_printConnectionHolder', true).forEach(function (conElem, connIdx) {
         if(Hafas('#adjustHelper_' + connIdx)) {
           Hafas('#adjustHelper_' + connIdx).style.height = (getElemOffset(conElem).top - getElemOffset(Hafas('#HFS_printConnectionToolbox_' + connIdx)).top) + 'px';
         }

         // details-button
         if (Hafas('#adjustHelperToolboxDetails_' + connIdx)){
           //Hafas('#adjustHelperToolboxDetails_' + connIdx).style.height = (getElemOffset(Hafas('#HFS_printContent_' + connIdx + ' .lyr_conSection.lyr_section_0')).top - getElemOffset(Hafas('#HFS_printConnectionToolbox_' + connIdx + ' .lyr_tb_details_toggleDetails')).top) + 'px';

           // tarif-info-button
           // TODO DomElemente nachziehen aus alter VAO Version
         if(Hafas('#HFS_printContent_'+connIdx+' .lyr_tarifDetails')){
           Hafas('#adjustHelperToolboxTariff_'+connIdx).style.height = (getElemOffset(Hafas('#adjustHelperTariff_'+connIdx)).top - getElemOffset(Hafas('#HFS_printConnectionToolbox_'+connIdx+' .tb_tariffWrapper')).top) + 'px';

           // nicht angezeigt, dann platz in linken teil schaffen
           // TODO: Das hier kann noch ein Problemchen sein
           if(Hafas('#HFS_printContent_'+connIdx+' .lyr_tarifDetails').hidden){
             Hafas('#adjustHelperTariff_'+connIdx).style.height = getElemOuterHeight(Hafas('#HFS_printConnectionToolbox_'+connIdx+' .tb_tariffWrapper')) + 'px';
           }
         }

         // // details-button
          Hafas('#adjustHelperToolboxDetails_'+connIdx).style.height = (getElemOffset(Hafas('#HFS_printContent_'+connIdx+' .lyr_routeSections')).top - getElemOffset(Hafas('#HFS_printConnectionToolbox_'+connIdx+' .lyr_tb_details_toggleDetails')).top) +'px';

           // abschnitte
           Hafas('#HFS_printContent_' + connIdx + ' .lyr_conSection', true).forEach(function (sectionElem, sectionIndex) {

             if (Hafas('#HFS_printConnectionToolbox_' + connIdx + ' .lyr_tb_detailsSection.section_' + sectionIndex)) {

               // nur detailliert fortsetzen, wenn section sichtbar ist
               if (sectionElem.hasClassName('hiddenDetails') === false) {

                 // button fuer turn-by-turn-karten
                 if (Hafas('#tb_toggleDirectionsButton_' + connIdx + '_' + sectionIndex)) {
                   Hafas('#HFS_adjustHelperSection_' + connIdx + '_' + sectionIndex + '_directions').style.height = (getElemOffset(Hafas('#HFS_printContent_' + connIdx + ' .lyr_conSection[data-section="' + sectionIndex + '"] .lyr_sectionDirectionsWrapper .lyr_moreDetailsHeader')).top - getElemOffset(Hafas('#HFS_tb_detailsSectionDirectionsButtons_' + connIdx + '_' + sectionIndex + ' > .tb_toggleButton')).top) + 'px';
                 }

                 // turn-by-turn karten (falls vorhanden)
                 var tbtWrapper = Hafas('#HFS_printContent_' + connIdx + ' .lyr_conSection[data-section="' + sectionIndex + '"] .lyr_moreDetailsContent.lyr_directions');
                 if (tbtWrapper && !tbtWrapper.hidden) {
                   Hafas('#HFS_printContent_' + connIdx + ' .lyr_conSection[data-section="' + sectionIndex + '"] .lyr_directionWrapper', true).forEach(function (segmentElem, segmentIndex) {
                     var segWrapper = Hafas('#HFS_tb_sectionSegmentWrapper_' + connIdx + '_' + sectionIndex + '_' + segmentIndex);
                     if (segWrapper) {
                       var height = getElemOffset(segmentElem).top - getElemOffset(segWrapper).top;
                       if (height < 0) {
                         height = 0;
                       }
                       Hafas('#adjustHelperSection_' + connIdx + '_' + sectionIndex + '_' + segmentIndex).style.height = height + 'px';
                     }
                   });
                 }

               }

               // gesamthoehe der section angleichen
               var contentElem = Hafas('#HFS_printContent_' + connIdx + ' .lyr_conSection[data-section="' + sectionIndex + '"]');
               var toolboxElem = Hafas('#HFS_printConnectionToolbox_' + connIdx + ' .lyr_tb_detailsSection.section_' + sectionIndex);

               if (getElemOuterHeight(contentElem) > getElemOuterHeight(toolboxElem)) {
                 Hafas('#HFS_printConnectionToolbox_' + connIdx + ' .lyr_tb_detailsSection.section_' + sectionIndex + ' .adjustHelperSection_end_right').style.height = (getElemOuterHeight(contentElem) - getElemOuterHeight(toolboxElem)) + 'px';
               }
               else if (getElemOuterHeight(contentElem) < getElemOuterHeight(toolboxElem)) {
                 Hafas('#HFS_printContent_' + connIdx + ' .lyr_conSection[data-section="' + sectionIndex + '"] .adjustHelperSection_end_left').style.height = (getElemOuterHeight(toolboxElem) - getElemOuterHeight(contentElem)) + 'px';
               }

             }

           });
         }
       });

    var toolboxDiv = Hafas('#HFS_printConfigurator');
    if(toolboxDiv){
      toolboxDiv.style.opacity = '';
    }
  }
  Hafas.ps.sub('/printConfigurator/updateToolboxPosition', updateToolboxPosition);

  // Weitere Anmeldungen für den Print Configurator
  var _me = HafasWebapp.prototype;
  // Wird für die Messages benutzt
  Hafas.ps.sub('/GUI/common/atomToggleContainer', Hafas.bind(_me.Controller.GUI.common.atomToggleContainer, _me));

  // resize Funktion zum Setzen der Layout-Klassen
  Hafas.ps.sub('/app/events/resize', Hafas.bind(_me.Controller.GUI.resize, _me));
};
